
export const StoreCodeView = (props:{titleStatus:string}) => {
  return (
    <div className="title-box">
      <div style={{ margin: "1em 0 0 0", display: "flex", justifyContent: "flex-start" }}>
          <span style={{ color: "slategrey" }}>
              {props.titleStatus}
          </span>
      </div>                
    </div>
  )
}
